// services/accountsService.ts

import config from "../config";
import { Account } from "../helpers/HelperInterfaces"

interface FetchAccountsResponse {
  accounts: Account[]
}

export interface CreateAccountPayload {
  accountName: string;
  accountType: string;
  openingBalance: number;
}

export interface ToggleAccountPayload {
    accountId: string;
    isEnabled: boolean;
  }

export interface UpdateAccountsPayload {
  favoriteIds?: string[];
  unfavoriteIds?: string[];
  enableIds?: string[];
  disableIds?: string[];
}
  
const BASE_URL = config.backendUrl;

/** GET /user/:id/account/ - Get account */
export async function fetchAccounts(userId: number): Promise<Account[]> {
  const response = await fetch(`${BASE_URL}/user/${userId}/account`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  if (!response.ok) {
    throw new Error(`Failed to fetch accounts: ${response.statusText}`);
  }
  return response.json()
  .then((rawData) => {

    const accounts: Account[] = rawData.map((a: any): Account => {
      return {
        accountId: a.id,
        accountName: a.name,
        accountTypeId: a.accountTypeId,
        createdDate: a.createdDate,
        updatedDate: a.updatedDate,
      }
    });
    return accounts;
});
}

/** POST /user/:id/account — create a new account */
export async function createAccount(
  userId: number,
  payload: CreateAccountPayload
): Promise<void> {
  const response = await fetch(`${BASE_URL}/user/${userId}/account`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    throw new Error(`Failed to create account: ${response.statusText}`);
  }
}

/** PATCH /user/:id/account — enable or disable or favorite or unfavorite accounts */
export async function updateAccounts(
  userId: number,
  payload: UpdateAccountsPayload
): Promise<void> {
  const response = await fetch(`${BASE_URL}/user/${userId}/account`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    throw new Error(`Failed to update accounts: ${response.statusText}`);
  }
}


/** GET /user/account/types - Get account types */
export async function fetchAccountTypes(): Promise<string[]> {
  const response = await fetch(`${BASE_URL}/user/account/types`);
  if (!response.ok) {
    throw new Error(`Failed to fetch account types: ${response.statusText}`);
  }
  return response.json();
}

  /** PUT /user/:id/account — enable or disable an account */
  export async function toggleAccount(
    userId: number,
    payload: ToggleAccountPayload
  ): Promise<void> {
    const response = await fetch(`${BASE_URL}/user/${userId}/account`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      throw new Error(`Failed to update account: ${response.statusText}`);
    }
  }